import React from 'react';

import {
  MCButton,
  MCText,
  PrefixField,
  Spinner,
  SuffixField,
  TextField
} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import AlertManager from 'src/components/alert';

import {
  withRouter,
  lang,
  scssVariables as variables,
  userFullName,
  checkSameAsAvatar
} from 'src/helpers';

import model from './model';
import locationModel from 'src/components/location/model';
import { Link } from 'react-router-dom';
import AuthContainer from 'src/components/AuthContainer';
import { BASE_ICONS } from 'src/components/svg';
import LANG_CONST from 'src/helpers/lang/const';
import { ThumbnailUploader } from 'src/components/complex';

class ClinicDoctorSignIn extends BaseComponent {
  state = { clinic: null };
  componentDidMount() {
    model.subscribe(this.subscription);

    model.checkInvite(
      new URLSearchParams(this.props.router.location.search).get('code'),
      (error, data) => {
        let isDoctor = !error && data?.invitation?.role?.includes('doctor_');
        let url = '/';
        if (!isDoctor && data?.joinToUser?.username) url = '/' + data.joinToUser.username;

        switch (data?.status) {
          case 'new':
            if (isDoctor)
              model.emit(
                'logout',
                '/signup-doctor' +
                  this.props.router.location.search +
                  '&clinicUsername=' +
                  data.joinToUser?.username
              );
            else model.emit('logout', '/signup' + this.props.router.location.search);
            break;
          case 'exist':
            this.setState({ clinic: isDoctor && data.joinToUser, avatars: data.avatars || [] });
            break;
          case 'joined':
            this.handleJoined(data);
            break;
          default:
            setTimeout(() => {
              this.navigate(url);
            }, 10000);
            break;
        }
      }
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    model.joinInvite(
      new URLSearchParams(this.props.router.location.search).get('code'),
      model.state.username,
      (error, data) => {
        if (!error) {
          this.handleJoined(data);
        }
      }
    );
  };

  handleJoined = (data) => {
    let isDoctor = data.invitation?.role?.includes('doctor_');
    let url = '/';
    if (!isDoctor && data.joinToUser?.username) url = '/' + data.joinToUser.username;

    if (data?.session) {
      model.emit('resetStates');
      model.emit('auth', data.session);
      model.foxsocket().disconnect();
      model.foxsocket().ensureConnect(true);
      locationModel.refresh();
    }
    setTimeout(() => {
      AlertManager.popup(AlertManager.TYPES.MOBILE_INFO, {
        width: 450,
        title: (
          <MCText
            size={20}
            weight={500}
            label={LANG_CONST.notice.join_title}
            style={{ textAlign: 'center' }}
          />
        ),
        titleEx: (
          <MCText
            size={20}
            label={lang.t(
              isDoctor ? LANG_CONST.notice.joined_clinic : LANG_CONST.notice.you_joined,
              {
                name: userFullName(data.joinToUser)
              }
            )}
          />
        ),
        actionButton: {
          label: LANG_CONST.buttons.continue,
          action: (props) => props.hide()
        }
      });
    }, 200);
    this.navigate(url);
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const createStateOfCheckInvite = model.getApiState('checkInvite');
    const createState = model.getApiState('joinInvite');
    const { loading, errorMessage, invalid } = createState;

    if (createState.error === 'URLNAME_TAKEN') {
      invalid['username'] = createState.errorMessage;
      createState.error = null;
    }
    return createStateOfCheckInvite.loading ? (
      <div className={'mc-flex-col'} style={{ height: '100%' }}>
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      </div>
    ) : createStateOfCheckInvite.errorMessage ? (
      <div className={'mc-flex-col'} style={{ height: '100%' }}>
        <div className={'mc-m-auto mc-flex-20-col'}>
          <span className={'mc-error'}>
            {createStateOfCheckInvite.errorMessage || createStateOfCheckInvite.error?.error}
          </span>
          <MCButton
            iconname={BASE_ICONS.BACK_ARROW}
            label={LANG_CONST.buttons.back_to_app}
            primary
            transparent
            onClick={(e) => {
              e.preventDefault();
              this.navigate('/');
            }}
          />
        </div>
      </div>
    ) : (
      this.state.clinic && (
        <AuthContainer>
          <div className={'mc-page-auth-box'}>
            {!!createState.error && <p className='mc-error'>{errorMessage}</p>}
            <form className='mc-form' onSubmit={this.handleSubmit}>
              <ThumbnailUploader
                type={'round'}
                image={model.input('avatar')}
                setImage={(data) => {
                  if (data)
                    checkSameAsAvatar(data, this.state.avatars || []).then((error) => {
                      if (error)
                        return model.setInvalidApi('joinInvite', {
                          avatar: error
                        });
                      model.handleChange('avatar', data);
                    });
                  else model.handleChange('avatar', '');
                }}
                autoLoad={true}
                activeCloseBtn={false}
                style={{ width: 90, height: 90, alignSelf: 'center' }}
              />
              <TextField
                prefixEl={this.state?.clinic && <PrefixField>dr.</PrefixField>}
                suffixEl={
                  this.state?.clinic && <SuffixField>.{this.state.clinic?.username}</SuffixField>
                }
                template={6}
                autoFocus={true}
                name={'username'}
                value={model.input('username')}
                onChange={(n, v) => {
                  model.resetApiState('joinInvite');
                  model.handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                label={LANG_CONST.choose_your_username}
                invalid={invalid}
              />

              <MCButton
                large
                radius
                type='submit'
                disabled={loading}
                primary
                dark
                label={
                  loading
                    ? lang.t(LANG_CONST.processing) + '...'
                    : this.state?.clinic
                      ? lang.t(LANG_CONST.buttons.joined, {
                          clinic: userFullName(this.state.clinic)
                        })
                      : LANG_CONST.buttons.continue
                }
              />
              <div className='mc-label-420'>
                <span className=''>{lang.t(LANG_CONST.back_to_txt)} </span>
                <Link
                  to={'/login'}
                  onClick={() => model.resetApiState('joinInvite')}
                  style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
                >
                  {lang.t(LANG_CONST.log_in)}
                </Link>
              </div>
            </form>
          </div>
        </AuthContainer>
      )
    );
  }
}

export default withRouter(ClinicDoctorSignIn);
